import React from 'react';
import { usePagination, DOTS } from '../utils/usePagination';
import LinkButton from './LinkButton';
import '../css/pagination.sass';

export interface PaginationProps {
  onPageChange: (currentPage: number) => void;
  totalResultsCount: number;
  currentPage: number;
  resultsPerPage: number;
  nextBtnLabel?: string;
  backBtnLabel?: string;
  noOfPagesToShow?: number;
}

export const Pagination = (props: PaginationProps) => {
  const {
    onPageChange,
    totalResultsCount,
    currentPage,
    resultsPerPage,
    noOfPagesToShow = 5,
    nextBtnLabel = 'Next',
    backBtnLabel = 'Back'
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalResultsCount,
    resultsPerPage,
    noOfPagesToShow
  });

  if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  return (
    <nav aria-label="pagination-nav" className="pagination-bar">
      <ul className=" pagination-container">
        <li className={`pagination-item${currentPage === 1 ? ' hidden' : ''}`}>
          <LinkButton
            ariaLabel={backBtnLabel}
            onClick={onPrevious}
            name={backBtnLabel}
            id="backBtn"
          >
            <div className="arrow">
              <span className="arrow-left"></span>
              <span className="left">{backBtnLabel}</span>
            </div>
          </LinkButton>
        </li>
        {paginationRange &&
          paginationRange.map((pageNumber: any) => {
            if (pageNumber === DOTS) {
              return <li className="pagination-item dots">&#8230;</li>;
            }

            return (
              <li
                className={`pagination-item page-number${
                  pageNumber === currentPage ? ' selected' : ''
                }`}
                key={pageNumber.toString()}
              >
                <LinkButton
                  ariaLabel={
                    pageNumber === currentPage
                      ? pageNumber.toString()
                      : undefined
                  }
                  onClick={() => onPageChange(pageNumber)}
                  name={`pageNumber-${pageNumber.toString()}`}
                  id={`pageNumber-${pageNumber.toString()}`}
                  ariaCurrent={pageNumber === currentPage ? 'page' : false}
                >
                  <h2 className="sr-only">Results Navigation</h2> {pageNumber}
                </LinkButton>
              </li>
            );
          })}

        <li
          className={`pagination-item${
            currentPage === noOfPagesToShow ? ' hidden' : ''
          }`}
        >
          <LinkButton
            ariaLabel={nextBtnLabel}
            onClick={onNext}
            name={nextBtnLabel}
            id="nextBtn"
          >
            <div className="arrow">
              <span className="right">{nextBtnLabel}</span>
              <span className="arrow-right"></span>
            </div>
          </LinkButton>
        </li>
      </ul>
    </nav>
  );
};
